export const crearHeadersApi = (accept = "application/json, text/plain", accessToken = "") => ({
  Accept: accept,
  "Content-Type": "application/json;charset=UTF-8",
  ...(accessToken ? { "X-PISEUN-Authorization": `Bearer ${accessToken}` } : {}),
});

export const extraerMensajeError = (contenido, status) =>
  contenido?.Error || contenido?.Message || contenido?.error || `Error HTTP ${status}`;

export const mensajeHttpSeguro = (status, contenido) => {
  if (Number(status) === 403) return "No tiene permiso para realizar esta operación";
  if (Number(status) >= 500) return "El servicio no está disponible. Intente nuevamente más tarde.";
  return extraerMensajeError(contenido, status);
};
